import { FETCH_SKILL, FETCH_USER_CHAT_SKILL_HISTORY, KEEP_SCROLL_POSITION } from "../actions/types";
import _ from "lodash";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_SKILL:
      let returnProps = {
        ...state,
        ...action.payload
      };
      return returnProps;
    default:
      return state;
  }
}
